import fetch from 'utils/request';
import { sift_query_list } from 'utils/sift';
import { deepCopy, formatDate } from 'utils/index';

// ! 获取登录人资源库列表
export function apiPostKnowledgeResourceJWTByList(data){
    return fetch({
        url: '/assistant/sys/assistant/resource/getUserResourceList.json',
        method: 'post',
        data: data,
		contentType: 'formData'
    });
}

// ! 获取资源库列表  分页
export function apiPostKnowledgeResourceSelectEntityByList(data) {
	return fetch({
        url: '/assistant/sys/assistant/resource/selectEntityListByPage.json',
        method: 'post',
        data: data,
		contentType: 'formData'
    });
}

// ! 获取资源库列表
export function apiPostKnowledgeResourceByList(data){
    return fetch({
        url: '/assistant/sys/assistant/resource/selectResourceListByProjectId.json',
        method: 'post',
        data: data,
		contentType: 'formData'
    });
}

// ! 获取Tree
export function apiPostKnowledgeTreeList(data) {
	return fetch({
		url: '/assistant/sys/assistant/tree/selectTreeListByResourceId.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 获取Tree
export function apiPostKnowledgeSelectTreeList(data) {
	return fetch({
		url: '/assistant/sys/assistant/tree/selectTreeListByResourceIdAndParentId.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 获取QA列表
export function apiPostKnowledgeQAList(data) {
	return fetch({
		url: '/assistant/sys/assistant/qa/selectEntityListByPage.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 获取QA详情
export function apiPostKnowledgeQAInfo(data) {
	return fetch({
		url: '/assistant/sys/assistant/qa/getQAById.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 获取QA查看量
export function apiPostKnowledgeSetQAClick(data) {
	return fetch({
		url: '/assistant/sys/assistant/qa/setQaClick.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 搜索 - 全文
export function apiPostKnowledgeSearchAll(data) {
	data = deepCopy(data);
	// delete data.resourceId;
	if(data.resourceIds) data.resourceIds = data.resourceIds.toString();
	data.type = data.types;
	delete data.treeId;
	delete data.types;
	delete data.resourceIdsTem;
	return fetch({
		url: '/assistant/sys/assistant/qa/search.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 搜索 - 智能
export function apiPostKnowledgeSearchIntelligent(data) {
	data = deepCopy(data);
	// delete data.resourceId;
	if(data.resourceIds) data.resourceIds = data.resourceIds.toString();
	data.type = data.types;
	delete data.treeId;
	delete data.types;
	delete data.resourceIdsTem;
	return fetch({
		url: '/assistant/sys/assistant/qa/searchNlp.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! New - QA
export function apiPostKnowledgeSelectNewQaList() {
	return fetch({
		// url: '/assistant/sys/assistant/qa/selectQAPushList.json',
		url: '/assistant/sys/assistant/qa/getUserQAPushList.json',
		method: 'post',
		// data: data,
		// contentType: 'formData'
	});
}

// ! New - QA - SET
export function apiPostKnowledgeSelectNewQaListSet(data) {
	return fetch({
		url: '/assistant/sys/assistant/qa/selectQAPushList.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 新增知识
export function apiPostKnowledgeQaCreate(data) {
	data = deepCopy(data);
	data.a = JSON.stringify(data.a);
	data.relationIds = data.relationIds.toString();
	return fetch({
		url: '/assistant/sys/assistant/qa/addEntity.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 编辑知识
export function apiPostKnowledgeQaUpdate(data) {
	data = deepCopy(data);
	data.a = JSON.stringify(data.a);
	data.relationIds = data.relationIds.toString();
	return fetch({
		url: '/assistant/sys/assistant/qa/updEntity.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 编辑知识
export function apiPostKnowledgeQaDelete(data) {
	return fetch({
		url: '/assistant/sys/assistant/qa/delEntity.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 编辑知识
export function apiPostKnowledgeSetHelp(data) {
	return fetch({
		url: '/assistant/sys/assistant/qa/setQAHelp.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 联想面板
export function apiPostKnowledgeSelectQAByKeyWord(data) {
	data = deepCopy(data);
	// delete data.resourceId;
	if(data.resourceIds) data.resourceIds = data.resourceIds.toString();
	data.type = data.types;
	delete data.treeId;
	delete data.types;
	delete data.resourceIdsTem;
	return fetch({
		// url: '/assistant/sys/assistant/qa/selectQAByKeyWord.json',
		url: '/assistant/sys/assistant/qa/selectQAByKeyWord.json',
		method: 'post',
		data: sift_query_list(data),
		contentType: 'formData'
	});
}

// ! 添加资源库
export function apiPostKnowledgeAddResourceEntity(data) {
	return fetch({
		url: '/assistant/sys/assistant/resource/addEntity.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 编辑资源库
export function apiPostKnowledgeEditResourceEntity(data) {
	return fetch({
		url: '/assistant/sys/assistant/resource/updEntity.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 删除资源库
export function apiPostKnowledgeDeleteResourceEntity(data) {
	return fetch({
		url: '/assistant/sys/assistant/resource/delEntity.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 新增Tree
export function apiPostKnowledgeAddTreeEntity(data) {
	return fetch({
		url: '/assistant/sys/assistant/tree/addEntity.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 批量新增QA
export function apiPostKnowledgeBatchAddQA(data) {
	return fetch({
		url: '/assistant/sys/assistant/qa/importExcelFile.json',
		method: 'post',
		data: data
	});
}

// ! 编辑Tree
export function apiPostKnowledgeEditTreeEntity(data) {
	return fetch({
		url: '/assistant/sys/assistant/tree/updEntity.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 删除Tree
export function apiPostKnowledgeDeleteTreeEntity(data) {
	return fetch({
		url: '/assistant/sys/assistant/tree/delEntity.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 相关文章
export function apiPostKnowledgeSelectQAOnlyList(data) {
	return fetch({
		url: '/assistant/sys/assistant/qa/selectQAOnlyQList.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 报表 - 文章点击
export function apiPostKnowledgeQaClickList(data, type) {
	data = deepCopy(data);
	const year = new Date(data.date).getFullYear();
	const month = new Date(data.date).getMonth();
	const day = new Date(data.date).getDate();
	function weekFormat(currentTime) {
		let currentDate = new Date(currentTime)
		let timesStamp = currentDate.getTime();
		let currenDay = currentDate.getDay();
		let dates = [];
		for (let i = 0; i < 7; i++) {
			dates.push(new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7)).toLocaleDateString().replace(/\//g, '-'));
		}
		return dates;
	}
	if(data.date) {
		switch(data.dateType) {
			case 'date': {
				data.start_date = dayjs(new Date(year, month, day)).format('YYYY-MM-DD');
				data.end_date = dayjs(new Date(year, month, day)).format('YYYY-MM-DD');
				break;
			}
			case 'week': {
				data.start_date = weekFormat(data.date)[0];
				data.end_date = weekFormat(data.date)[6];
				break;
			}
			case 'month': {
				data.start_date = dayjs(new Date(year, month, 1)).format('YYYY-MM-DD');
				data.end_date = dayjs(new Date(year, month, new Date(year, month+1, 0).getDate())).format('YYYY-MM-DD');
				break;
			}
		}
	}
	if(type == 'export') {
		delete data.pageNum;
		delete data.pageSize;
	}
	delete data.dateType;
	delete data.date;

	return fetch({
		// url: type == 'export' ? '/assistant/sys/assistant/qaclick/exportExcel.json' : '/assistant/sys/assistant/qaclick/selectEntityListByPage.json',
		url: type == 'export' ? '/assistant/sys/assistant/qaclick/exportExcel.json' : '/assistant/sys/assistant/qaclick/getUserQAClickListByPage.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 报表 - 关键字搜索
export function apiPostKnowledgeQaSearchList(data, type) {
	data = deepCopy(data);
	const year = new Date(data.date).getFullYear();
	const month = new Date(data.date).getMonth();
	const day = new Date(data.date).getDate();
	function weekFormat(currentTime) {
		let currentDate = new Date(currentTime)
		let timesStamp = currentDate.getTime();
		let currenDay = currentDate.getDay();
		let dates = [];
		for (let i = 0; i < 7; i++) {
			dates.push(new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7)).toLocaleDateString().replace(/\//g, '-'));
		}
		return dates;
	}
	if(data.date) {
		switch(data.dateType) {
			case 'date': {
				data.start_date = dayjs(new Date(year, month, day)).format('YYYY-MM-DD');
				data.end_date = dayjs(new Date(year, month, day)).format('YYYY-MM-DD');
				break;
			}
			case 'week': {
				data.start_date = weekFormat(data.date)[0];
				data.end_date = weekFormat(data.date)[6];
				break;
			}
			case 'month': {
				data.start_date = dayjs(new Date(year, month, 1)).format('YYYY-MM-DD');
				data.end_date = dayjs(new Date(year, month, new Date(year, month+1, 0).getDate())).format('YYYY-MM-DD');
				break;
			}
		}
	}
	if(type == 'export') {
		delete data.pageNum;
		delete data.pageSize;
	}
	delete data.dateType;
	delete data.date;

	return fetch({
		url: type == 'export' ? '/assistant/sys/assistant/qasearch/exportExcel.json' : '/assistant/sys/assistant/qasearch/selectEntityListByPage.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 资源库排序
export function apiPostKnowledgeResourceSort(data) {
	return fetch({
		url: '/assistant/sys/assistant/resource/adjustDragOrder.json',
		method: 'post',
		data: data
	});
}

// ! Tree排序
export function apiPostKnowledgeTreeSort(data) {
	return fetch({
		url: '/assistant/sys/assistant/tree/adjustDragOrder.json',
		method: 'post',
		data: data
	});
}

// ! 审核列表
export function apiPostKnowledgeQATaskList(data) {
	return fetch({
		// url: '/assistant/sys/assistant/qatask/selectEntityListByPage.json',
		url: '/assistant/sys/assistant/qatask/getUserQATaskListByPage.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 审核文章
export function apiPostKnowledgeQATaskApproveQAUpd(data) {
	return fetch({
		url: '/assistant/sys/assistant/qatask/approveQaUpd.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 申请修改知识文章
export function apiPostKnowledgeQATaskApplyQAUpd(data) {
	data = deepCopy(data);
	data = deepCopy(data);
	data.a = JSON.stringify(data.a);
	data.relationIds = data.relationIds.toString();
	delete data.id;
	delete data.resourceIds;
	delete data.treeId;
	delete data.status;
	delete data.relationIds;
	return fetch({
		url: '/assistant/sys/assistant/qatask/applyQaUpd.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 修改知识的详情
export function apiPostKnowledgeQATaskGetEntityById(data) {
	return fetch({
		url: '/assistant/sys/assistant/qatask/getEntityById.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 消息列表
export function apiPostKnowledgeMessageList(data) {
	return fetch({
		url: '/assistant/sys/assistant/message/selectEntityListByPage.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 全部已读
export function apiPostKnowledgeMessageUpdReadByUser(data) {
	return fetch({
		url: '/assistant/sys/assistant/message/updMessageReadByUser.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 修改QA推送状态
export function apiPostKnowledgeQAUpdPush(data) {
	return fetch({
		url: '/assistant/sys/assistant/qa/updQAPush.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 获取相关配置
export function apiPostKnowledgeProjectGetEntity(data) {
	return fetch({
		url: '/assistant/sys/assistant/project/getEntityById.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 修改相关配置
export function apiPostKnowledgeProjectSetEntity(data) {
	return fetch({
		url: '/assistant/sys/assistant/project/updEntity.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 修改相关配置
export function apiPostKnowledgeMessageGetEntityById(data) {
	return fetch({
		url: '/assistant/sys/assistant/message/getEntityById.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 修改相关配置
export function apiPostKnowledgeMessageCount(data) {
	return fetch({
		url: '/assistant/sys/assistant/message/selectMessageReadCount.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}


// ! 查询List数据by分页(根据资源库ID查询当前下面的组)
export function apiPostKnowledgeSelectResourceGroupList(data) {
	return fetch({
		url: '/assistant/sys/assistant/resource/selectResourceGroupListByPage.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 查询List数据by分页(根据资源库ID查询当前下面的人)
export function apiPostKnowledgeSelectResourceUserList(data) {
	return fetch({
		url: '/assistant/sys/assistant/resource/selectResourceUserListByPage.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 新增资源库与组关系
export function apiPostKnowledgeResourceAddResourceGroup(data) {
	data = deepCopy(data);
	if(data.groupIds) data.groupIds = data.groupIds.toString();
	return fetch({
		url: '/assistant/sys/assistant/resource/addResourceGroups.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 新增资源库与用户关系
export function apiPostKnowledgeResourceAddResourceUser(data) {
	data = deepCopy(data);
	if(data.userIds) data.userIds = data.userIds.toString();
	return fetch({
		url: '/assistant/sys/assistant/resource/addResourcesUser.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 修改资源库内组权限
export function apiPostKnowledgeResourceEditResourceGroup(data) {
	return fetch({
		url: '/assistant/sys/assistant/resource/updResourceGroupRight.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 修改资源库内人权限
export function apiPostKnowledgeResourceEditResourceUser(data) {
	return fetch({
		url: '/assistant/sys/assistant/resource/updResourceUserRight.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 删除资源库与组关系
export function apiPostKnowledgeResourceDeleteResourceGroup(data) {
	return fetch({
		url: '/assistant/sys/assistant/resource/delResourceGroup.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 删除资源库与用户关系
export function apiPostKnowledgeResourceDeleteResourceUser(data) {
	return fetch({
		url: '/assistant/sys/assistant/resource/delResourceUser.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 批量上传知识
export function apiPostKnowledgeBatchImportQa(data) {
	return fetch({
		url: '/assistant/sys/assistant/qa/importExcelFile.json',
		method: 'post',
		data: data
	});
}
// 未审批任务计数
export function getApprovalListCountApi(data) {
	return fetch({
		url: '/assistant/sys/assistant/approvallist/count',
		method: 'post',
		data: data
	});
}